import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getBrand, updateBrand} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateBrandForm extends Component {
  componentDidMount() {
    this._loadBrand();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.brandId !== this.props.match.params.brandId) {
      this._loadBrand();
    }
  }

  _loadBrand = () => {
    const {brandId} = decodeParams(this.props.match.params);
    this.props.getBrand({brandId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {brandId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateBrand({...values, brandId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {brand, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name, description} = brand;
    return (
      <Card title="Update Brand">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: description
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Brand
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateBrandForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  getBrand: PropTypes.func.isRequired,
  updateBrand: PropTypes.func.isRequired
};

const UpdateBrandPage = Form.create()(UpdateBrandForm);

const mapStateToProps = state => ({
  loading: state.brand.brandLoading || state.brand.updatingBrand,
  brand: state.brand.brand || {}
});

const mapDispatchToProps = dispatch => ({
  getBrand: payload => (dispatch(getBrand(payload))),
  updateBrand: payload => (dispatch(updateBrand(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateBrandPage);



// WEBPACK FOOTER //
// ./src/Brand/UpdateBrandPage.js